var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "dd",
    { class: _vm._f("klass")(_vm.validate.$error) },
    [
      _vm.validate.$error
        ? [
            _c("span", { staticClass: "errNote" }, [
              _vm._v("性別を選択してください。"),
            ]),
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("label", { staticClass: "select" }, [
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.validate.$model,
                expression: "validate.$model",
              },
            ],
            attrs: { name: "sex_kbn" },
            on: {
              change: [
                function ($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function (o) {
                      return o.selected
                    })
                    .map(function (o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.$set(
                    _vm.validate,
                    "$model",
                    $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                  )
                },
                _vm.setUserInfoPatch,
              ],
            },
          },
          [
            _c("option", { attrs: { value: "0", selected: "" } }, [
              _vm._v("無回答"),
            ]),
            _vm._v(" "),
            _c("option", { attrs: { value: "1" } }, [_vm._v("男性")]),
            _vm._v(" "),
            _c("option", { attrs: { value: "2" } }, [_vm._v("女性")]),
          ]
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }